export default "__VITE_ASSET__DCVL6rzE__"